<template>
  <div>
    <h6 class="mt-3 mb-3">Proposta e fechamento</h6>
    <!-- eslint-disable vue/no-mutating-props -->
    <div class="row">
      <div class="form-group col-md-3">
        <label for="proposal_date">Data da proposta</label>
        <input type="date" class="form-control" id="proposal_date" v-model="item.proposal_date" />
      </div>
      <div class="form-group col-md-3">
        <label for="proposal_value">Valor da proposta (R$)</label>
        <input type="number" step="0.01" min="0" class="form-control" id="proposal_value" v-model="item.proposal_value" />
      </div>
      <div class="form-group col-md-3">
        <label for="closing_type">Fechamento matrícula</label>
        <select id="closing_type" class="form-control" v-model="item.closing_type">
          <option :value="null">-- Selecione --</option>
          <option value="Matrícula">Matrícula (comissão 50%)</option>
          <option value="Competência">Competência (comissão 5%)</option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="closing_date">Fechamento data</label>
        <input type="date" class="form-control" id="closing_date" v-model="item.closing_date" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-3">
        <label for="closing_value">Fechamento valor (R$)</label>
        <input type="number" step="0.01" min="0" class="form-control" id="closing_value" v-model="item.closing_value" />
      </div>
      <div class="form-group col-md-3">
        <label for="payment_type_id">Forma pagamento</label>
        <select id="payment_type_id" class="form-control" v-model="item.payment_type_id">
          <option :value="null">-- Selecione --</option>
          <option v-for="paymentType in paymentTypes" :key="paymentType.id" :value="paymentType.id">
            {{ paymentType.name }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="bank">Banco</label>
        <input type="text" class="form-control" id="bank" maxlength="60" placeholder="Mercado Pago, Nubank, Inter..." v-model="item.bank" />
      </div>
      <div class="form-group col-md-3">
        <label for="amount_paid">Valor pago (R$)</label>
        <input type="number" step="0.01" min="0" class="form-control" id="amount_paid" v-model="item.amount_paid" />
        <small class="text-muted">Registrado no financeiro.</small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-6">
        <label for="card_holder">Cartão titular</label>
        <input type="text" class="form-control" id="card_holder" maxlength="150" v-model="item.card_holder" />
      </div>
      <div class="form-group col-md-3">
        <label for="card_last_digits">Cartão 4 últimos dígitos</label>
        <TheMask type="text" class="form-control" id="card_last_digits" :mask="['####']" v-model="item.card_last_digits" />
      </div>
      <div class="form-group col-md-3">
        <label for="paid_off">Quitado</label>
        <select id="paid_off" class="form-control" v-model="item.paid_off">
          <option :value="true">SIM</option>
          <option :value="false">NÃO</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-3">
        <label for="service_sent">Atendimento enviado</label>
        <select id="service_sent" class="form-control" v-model="item.service_sent">
          <option :value="true">SIM</option>
          <option :value="false">NÃO</option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="service_date">Atendimento data</label>
        <input type="date" class="form-control" id="service_date" v-model="item.service_date" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services";

export default {
  name: "CandidateClosingFields",
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      paymentTypes: [],
    };
  },
  async mounted() {
    const { data } = await api.get("/payment-types?page=0&perPage=99999&sortBy=name");
    this.paymentTypes = data.data;
  },
};
</script>
